// src/pages/Accounting/Reconcile/Session/sessionTypes.ts

export type TransactionKind =
  | "expense"
  | "receive-payment"
  | "payroll-cheque"
  | "bill-payment"
  | "tax-payment"
  | "transfer"
  | "deposit"
  | "payroll-adjustment"
  | "journal-entry";

export const TRANSACTION_KIND_LABELS: Record<TransactionKind, string> = {
  expense: "Expense",
  "receive-payment": "Receive Payment",
  "payroll-cheque": "Payroll Cheque",
  "bill-payment": "Bill Payment",
  "tax-payment": "Tax Payment",
  transfer: "Transfer",
  deposit: "Deposit",
  "payroll-adjustment": "Payroll Adjustment",
  "journal-entry": "Journal Entry",
};

export interface SessionTransactionRich {
  id: string;
  date: string;
  clearedDate?: string;
  kind: TransactionKind;
  refNo?: string;
  account: string;
  payee: string;
  memo?: string;
  amount: number;
  matchStatus: "matched" | "needs-review" | "unmatched";
  matchedNote?: string;
  velaMatched: boolean;
}

export type ColumnKey =
  | "clearedDate"
  | "type"
  | "refNo"
  | "account"
  | "payee"
  | "memo";

export const ALL_TOGGLEABLE_COLUMNS: ColumnKey[] = [
  "clearedDate",
  "type",
  "refNo",
  "account",
  "payee",
  "memo",
];

export const COLUMN_LABELS: Record<ColumnKey, string> = {
  clearedDate: "Cleared date",
  type: "Type",
  refNo: "Ref no.",
  account: "Account",
  payee: "Payee",
  memo: "Memo",
};

export const DEFAULT_VISIBLE_COLUMNS: ColumnKey[] = [
  "clearedDate",
  "type",
  "refNo",
  "account",
  "payee",
  "memo",
];

export type Density = "regular" | "compact" | "ultra";

export const DENSITY_LABELS: Record<Density, string> = {
  regular: "Regular",
  compact: "Compact",
  ultra: "Ultra compact",
};

export const DEFAULT_DENSITY: Density = "regular";

export type TabFilter = "all" | "payments" | "deposits";

export interface SessionFilterState {
  find: string;
  clearedStatus: "all" | "cleared" | "uncleared" | "needs-review";
  transactionType: TransactionKind | "all";
  payee: string;
  dateMode: "statement-period" | "custom";
  fromDate: string;
  toDate: string;
}

export const EMPTY_FILTER_STATE: SessionFilterState = {
  find: "",
  clearedStatus: "all",
  transactionType: "all",
  payee: "all",
  dateMode: "statement-period",
  fromDate: "",
  toDate: "",
};